import acmTheme from 'gatsby-theme-acm/src/gatsby-theme-core/layout/theme';

// const GRAY = '#3a4354';

export default {
  ...acmTheme,
  // fontSize: '16px',
  // baseLineHeight: '150%',
  // sectionSpacer: '3rem',
  fontFamily: 'Lato',
  // fontWeight: '400',
  fontColor: '#37373a',

  // backgroundColor: 'white',
  primaryColor: '#e1140d',

  // grayColor: GRAY,
  // grayLightColor: '#c3c9d5',
  // grayDarkColor: '#2C2A2A',

  // gray01: '#f3f4f7',
  // gray02: '#e7e9ee',
  // gray04: '#8793ab',

  pagebuilder: {
    backgroundGrey: acmTheme.gray01,
  },
  vehicle: {
    ...acmTheme.vehicle,
    withSectionWhatsapp: false,
  },

  ...(Number(process.env.GATSBY_STRAPI_SITE_ID) === 2 ? {
    primaryColor: '#ffa500',
  } : {}),
  ...(Number(process.env.GATSBY_STRAPI_SITE_ID) === 3 ? {
    primaryColor: '#388704',
  } : {}),
};
